import React from 'react';
import {starFill} from "../../assets/images/images";

function ProductReviewCard(props) {
  return (
    <tr className='display-flex'>
      <td className='icon'><p className='user-custom-icon'>.</p></td>
      <td className='name'>
        <p className='font-18 m-0 text-bold'>Jason Huang </p>
        <p className='m-0'>ajwa seed</p>
        <div className='mt-10'>
          <img src={starFill} width={15}/>
          <img src={starFill} width={15}/>
          <img src={starFill} width={15}/>
          <img src={starFill} width={15}/>
          <img src={starFill} width={15}/>
        </div>
      </td>
      <td className='desc'>Arrived as expected, well packed properly protected, looks good construction and finish. Arrived quickly and without any extra fee. 
      </td>
    </tr>
  );
}

export default ProductReviewCard;
